//REACT-JS
import React from 'react';
import { withRouter } from 'react-router-dom';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import { relatorioAction } from '../../store/relatorio';

class TableFaturamentoToi extends React.Component {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        name: "",
        selected: 0,
        onChange: function(e){}
    };

    render() {

        const data = this.props.data;
        let html = "";
        let footer = ""

        if (data.results === undefined) {
            html = (<tr><td colSpan="4" scope="row">Carregando...</td></tr>);
        }
        else if (data.results.length === 0 || data.results === 0) {
            html = (<tr><td colSpan="4" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length > 0) {
            html = data.results.map(row =>
                <tr key={row.descricao} id={row.descricao}>
                    <td>{row.descricao}</td>
                    <td>{row.quantidade}</td>
                </tr>                  
            );

            footer = <>
                <tr>
                    <td><strong>Total Geral</strong></td>
                    <td><strong>{data.totalGeral}</strong></td>
                </tr>
                <tr>
                    <td><strong>Total Não Faturado</strong></td>
                    <td><strong>{data.totalNaoFaturado}</strong></td>
                </tr>
                <tr>
                    <td><strong>Total Faturado</strong></td>
                    <td><strong>{data.totalFaturado}</strong></td>
                </tr>
            </>

        }

        return(
            <div style={{maxHeight: "400px", overflowY: "auto"}}>
                <table className="footable table table-striped toggle-arrow-tiny text-body" id="table-to-export">
                    <thead>
                        <tr style={{backgroundColor: "#dbf1e9"}}>       
                            <th>Motivo/Status</th>
                            <th>Quantidade</th>
                        </tr>
                    </thead>

                    <tbody>
                        {html}
                        {footer}
                    </tbody>
                </table>            
            </div>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableFaturamentoToi));